export default __webpack_public_path__ + "static/media/bg_daftar_pengetahuan.11ec93ed.webp";